import * as Sentry from '@sentry/angular';

const SentryConfig = {
  dsn: 'https://901ccb3aceb419aade47653c5d677704@o4508608103645184.ingest.de.sentry.io/4508641672626256',
};

export const sentryInit = (): void => {
  Sentry.init({
    dsn: SentryConfig.dsn,
    integrations: [],
  });
};
